import { render } from "./UserInviteComp.vue?vue&type=template&id=c3daf704&scoped=true&ts=true"
import script from "./UserInviteComp.vue?vue&type=script&lang=ts"
export * from "./UserInviteComp.vue?vue&type=script&lang=ts"

import "./UserInviteComp.vue?vue&type=style&index=0&id=c3daf704&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3daf704"]])

export default __exports__